import { trackUpgradeClickEvent } from "@/lib/analytics-events"

export const OPEN_UPGRADE_MODAL_EVENT = "openUpgradeSubscriptionModal"
export const NAVIGATE_TO_UPGRADE_EVENT = "navigateToUpgrade"

export type UpgradePlanSelection = "pro" | "pro_plus"

export type ProBillingInterval = "monthly" | "yearly"

/** Navigate to the Upgrade tab. On /admin: switches tab in-place. Elsewhere: redirects to /admin?tab=upgrade */
export function navigateToUpgrade() {
  if (typeof window === "undefined") return
  trackUpgradeClickEvent()
  if (window.location.pathname === "/admin") {
    window.dispatchEvent(new CustomEvent(NAVIGATE_TO_UPGRADE_EVENT))
  } else {
    window.location.href = "/admin?tab=upgrade"
  }
}

export function openUpgradeModal(
  selectedPlanId?: UpgradePlanSelection,
  openPaymentDirectly?: boolean,
  options?: {
    billingInterval?: ProBillingInterval
    /** Match onboarding: show $9.99/mo, charge YEARLY_FULL ($119.88/yr). */
    useOnboardingYearlyPricing?: boolean
  }
) {
  if (typeof window === "undefined") return
  const useOnboardingYearlyPricing = Boolean(options?.useOnboardingYearlyPricing)
  const billingInterval =
    useOnboardingYearlyPricing || options?.billingInterval === "yearly" ? "yearly" : "monthly"
  window.dispatchEvent(
    new CustomEvent(OPEN_UPGRADE_MODAL_EVENT, {
      detail: {
        selectedPlanId,
        openPaymentDirectly: Boolean(openPaymentDirectly),
        billingInterval,
        useOnboardingYearlyPricing,
      },
    })
  )
}
